module.exports = __webpack_public_path__ + "static/media/Metrex-Equities.38c23036.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/Metrex-Equities.jpg
// module id = 445
// module chunks = 0